"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyParticipantsFailure = exports.copyParticipantsSuccess = exports.copyParticipants = exports.selectBid = exports.toggleCopyParticipant = exports.toggleUserFromGroupSuccess = exports.toggleUserFromGroupFailure = exports.toggleUserFromGroup = exports.addParticipantsValidation = exports.addParticipantsFailed = exports.addParticipantsSuccess = exports.addParticipantsRequest = exports.addParticipantsLanguage = exports.addParticipantsUpdateRow = exports.addParticipantsRemoveRow = exports.addParticipantsAddRow = exports.toggleAddParticipant = exports.clear = exports.setOrderBy = exports.setColumnFilter = exports.setPaginationOptions = exports.setSearchString = exports.setInitData = exports.toggleSelect = exports.removeFailed = exports.removeSuccess = exports.removeRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/bid/participants");
function fetchRequest(bid) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: {
            bid
        }
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
// Remove
function removeRequest(bid, group, users) {
    return {
        type: ActionTypes.REMOVE_REQUEST,
        payload: {
            bid,
            group,
            users
        }
    };
}
exports.removeRequest = removeRequest;
function removeSuccess(users) {
    return {
        type: ActionTypes.REMOVE_SUCCESS,
        payload: users
    };
}
exports.removeSuccess = removeSuccess;
function removeFailed(payload) {
    return {
        type: ActionTypes.REMOVE_FAILED,
        payload
    };
}
exports.removeFailed = removeFailed;
// Toggle
function toggleSelect(select, participant) {
    return {
        type: ActionTypes.TOGGLE_SELECT,
        payload: {
            select,
            participant
        }
    };
}
exports.toggleSelect = toggleSelect;
// Init
function setInitData(data) {
    return {
        type: ActionTypes.SET_INIT_DATA,
        payload: data
    };
}
exports.setInitData = setInitData;
function setSearchString(data) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        payload: data
    };
}
exports.setSearchString = setSearchString;
function setPaginationOptions(offset, limit) {
    return {
        type: ActionTypes.SET_PAGINATION_OPTIONS,
        payload: {
            offset,
            limit
        }
    };
}
exports.setPaginationOptions = setPaginationOptions;
function setColumnFilter(field, value) {
    return {
        type: ActionTypes.SET_COLUMN_FILTER,
        payload: {
            field,
            value
        }
    };
}
exports.setColumnFilter = setColumnFilter;
function setOrderBy(orderBy, order) {
    return {
        type: ActionTypes.SET_ORDER_BY,
        payload: {
            orderBy,
            order
        }
    };
}
exports.setOrderBy = setOrderBy;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
function toggleAddParticipant() {
    return {
        type: ActionTypes.TOGGLE_ADD_PARTICIPANT
    };
}
exports.toggleAddParticipant = toggleAddParticipant;
function addParticipantsAddRow(row) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_ADD_ROW,
        payload: row
    };
}
exports.addParticipantsAddRow = addParticipantsAddRow;
function addParticipantsRemoveRow(uuid) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_REMOVE_ROW,
        payload: uuid
    };
}
exports.addParticipantsRemoveRow = addParticipantsRemoveRow;
function addParticipantsUpdateRow(uuid, emails) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_UPDATE_ROW,
        payload: {
            uuid,
            emails
        }
    };
}
exports.addParticipantsUpdateRow = addParticipantsUpdateRow;
function addParticipantsLanguage(uuid, language) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_LANGUAGE_ROW,
        payload: {
            uuid,
            language
        }
    };
}
exports.addParticipantsLanguage = addParticipantsLanguage;
function addParticipantsRequest(bid, briefcase, invitations) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_REQUEST,
        payload: {
            bid,
            briefcase,
            invitations
        }
    };
}
exports.addParticipantsRequest = addParticipantsRequest;
function addParticipantsSuccess() {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_SUCCESS
    };
}
exports.addParticipantsSuccess = addParticipantsSuccess;
function addParticipantsFailed(error) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_FAILED,
        payload: error
    };
}
exports.addParticipantsFailed = addParticipantsFailed;
function addParticipantsValidation(error) {
    return {
        type: ActionTypes.ADD_PARTICIPANTS_VALIDATION,
        payload: error
    };
}
exports.addParticipantsValidation = addParticipantsValidation;
function toggleUserFromGroup(state, payload) {
    return {
        type: ActionTypes.TOGGLE_USER_FROM_GROUP,
        state,
        payload
    };
}
exports.toggleUserFromGroup = toggleUserFromGroup;
function toggleUserFromGroupFailure(error) {
    return {
        type: ActionTypes.TOGGLE_USER_FROM_GROUP_FAILURE,
        payload: error
    };
}
exports.toggleUserFromGroupFailure = toggleUserFromGroupFailure;
function toggleUserFromGroupSuccess() {
    return {
        type: ActionTypes.TOGGLE_USER_FROM_GROUP_SUCCESS
    };
}
exports.toggleUserFromGroupSuccess = toggleUserFromGroupSuccess;
function toggleCopyParticipant(status) {
    return { type: ActionTypes.TOGGLE_COPY_PARTICIPANT, payload: status };
}
exports.toggleCopyParticipant = toggleCopyParticipant;
function selectBid(bid) {
    return {
        type: ActionTypes.SELECT_BID,
        payload: {
            bid
        }
    };
}
exports.selectBid = selectBid;
function copyParticipants(selectedBid, targetBid, targetGroup) {
    return {
        type: ActionTypes.COPY_PARTICIPANT,
        payload: {
            selectedBid,
            targetBid,
            targetGroup
        }
    };
}
exports.copyParticipants = copyParticipants;
function copyParticipantsSuccess() {
    return {
        type: ActionTypes.COPY_PARTICIPANT_SUCCESS
    };
}
exports.copyParticipantsSuccess = copyParticipantsSuccess;
function copyParticipantsFailure(error) {
    return {
        type: ActionTypes.COPY_PARTICIPANT_FAILURE,
        payload: error
    };
}
exports.copyParticipantsFailure = copyParticipantsFailure;
//# sourceMappingURL=participants.js.map